import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RichTextComponent } from '../../../common/rich-text/rich-text.component';
import { BlockNode } from '../../../../types/rich-text.types';
import { ButtonComponent } from '../../../common/button/button.component';

@Component({
    selector: 'app-grid-section',
    imports: [TranslatePipe, RichTextComponent, ButtonComponent],
    templateUrl: './grid-section.component.html',
})
export class GridSectionComponent {
    blockNodes = input.required<BlockNode[]>();
    index = input.required<number>();
}
